import React, { useCallback, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import Page from "@smpu-web/globalmodules/page"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import Amount from "@smpu-web/nested/form/amount"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"
import Slider from "@bappweb/slider"
import Element from "@bappweb/element"
import Button from "@bappweb/button"
import Select from "@bappweb/select"
import CalculationDetail from "./calculationdetail"
import { useGetProductInfoMutation, usePreApply1Mutation } from "../../../api/services"
import { calculateMonthlyPayment } from "@smpu-web/utils/calculateinteresthome"
import { INSURED_PRODUCT_TYPE, UNINSURED_PRODUCT_TYPE, UNUSED_PRODUCT_TYPE, USED_PRODUCT_TYPE, HAS_ANOTHER_HOUSE, HAS_NOT_ANOTHER_HOUSE, MAX_USED_VALUE_ERROR_CODE, MAX_LTV_VALUE_ERROR_CODE, ILK_EVIM_UNINSURED_PRODUCT_TYPE, ILK_EVIM_INSURED_PRODUCT_TYPE } from "@smpu-web/utils/constants"
import { useAppDispatch } from "../../../config/hook"
import { setCustomerData } from "../../../state/customerdata"
import "../assets/style.scss"
import FormMessage from "@smpu-web/globalmodules/form-message"
import { UiInfo } from "@bappweb/icon"
import Block from "@bappweb/block"
import Tooltip from "@bappweb/tooltip"
import { getConfigValue, SMPUConfigListResponse } from "@smpu-web/utils/utils"

const getQuerystringValue = () => {
  let values = {
    amount: 300000, loanTerm: 120
  }
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams) {
    const tutar = queryParams.get("tutar")
    const vade = queryParams.get("vade")
    if (tutar) {
      values.amount = parseInt(tutar)
    }
    if (vade) {
      values.loanTerm = parseInt(vade)
    }
  }

  return values
}

type PropsType = {
  configValues: SMPUConfigListResponse[] | undefined,
  ilkEvim
}

const CalculateForm = ({ configValues, ilkEvim }: PropsType) => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const [details, setDetails] = useState({
    showSlider: false,
    amountChangedByUser: false,
    vadeChangedByUser: false
  })

  const [productMinsMaxs, setProductMinsMaxs] = useState({
    minVade: 1,
    maxVade: 120,
    maxAmount: 300000
  })

  const [error, setError] = useState<string | null>()

  const [aylikOdeme, setAylikOdeme] = useState(0)
  const [totalPaymentAmt, setTotalPaymentAmt] = useState(0)
  const [faizOrani, setFaizOrani] = useState(0)
  const [yearlyInterestRate, setYearlyInterestRate] = useState("")
  const [amount, setAmount] = useState(() => getQuerystringValue().amount)
  const [vade, setVade] = useState(() => getQuerystringValue().loanTerm)
  const [urunTipi, setUrunTipi] = useState(!ilkEvim ? "2" : "4")
  const [isCalledProductService, setIsCalledProductService] = useState(false)
  const [konutDegeri, setKonutDegeri] = useState(0)
  const [konutTuru, setKonutTuru] = useState("1")
  const [farkliKonutVarMiFlg, setFarkliKonutVarMiFlg] = useState(!ilkEvim ? "E" : "H")
  const [enerjiSinifi, setEnerjiSinifi] = useState<string>("")

  const [getProductInfoService, { isLoading }] = useGetProductInfoMutation()
  const [productDetail, setProductDetail] = useState({})

  const energyClassOptions = [{ id: "A", name: "A Sınıfı" }, { id: "B", name: "B Sınıfı" }, { id: "C", name: "C Sınıfı" }, { id: "D", name: "Diğer" }]

  ilkEvim ? document.title = "İlk Evim Konut Kredisi Hesaplama ve İlk Evim Konut Kredisi Başvurusu | Akbank" : null;

  useEffect(() => {
    // CleanUp fonksiyonu performans optimizasyonu kapsamında useEffect ile tetiklenen kodların fazladan çalıştırılmasının önüne geçilmek için eklenmiştir.
    const cleanupIdentifier = setTimeout(() => {
      if (!isCalledProductService) {
        getProductInfo()
      }
    }, 500)

    return () => {
      clearTimeout(cleanupIdentifier)
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [isCalledProductService])

  const getProductInfo = useCallback(() => {
    getProductInfoService({
      urunTip: urunTipi
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setProductDetail(payload)
          setProductMinsMaxs({
            minVade: payload.minVadeTl,
            maxVade: payload.maxVadeTl,
            maxAmount: parseInt(payload.maxTutar)
          })
          if (!details.amountChangedByUser && !details.vadeChangedByUser) {
            if (amount && vade) {
              const isAmountValid =
                !isNaN(amount) &&
                amount >= parseInt(payload.minTutar) &&
                amount <= parseInt(payload.maxTutar)

              const isVadeValid =
                !isNaN(vade) &&
                vade >= payload.minVadeTl &&
                vade <= payload.maxVadeTl

              let amountResult = productMinsMaxs.maxAmount,
                vadeResult = productMinsMaxs.maxVade

              if (isAmountValid) {
                amountResult = amount
              }
              if (isVadeValid) {
                vadeResult = vade
              }

              setAmount(amountResult)
              setVade(vadeResult)
              setDetails({
                ...details,
                showSlider: true
              })
            } else {
              setDetails({
                ...details,
                showSlider: true
              })
            }
          }
        }
      })
    setIsCalledProductService(true)
  }, [
    getProductInfoService,
    productMinsMaxs,
    details,
    urunTipi,
    amount,
    vade
  ])

  const calculatePayment = useCallback(() => {
    let result = {
      aylikOdeme: 0,
      faizOrani: 0,
      yearlyInterestRate: 0,
      totalPaymentAmt: 0
    }

    if (Object.keys(productDetail).length !== 0) {
      result = calculateMonthlyPayment(amount, vade, productDetail, Number(getConfigValue(configValues, "WebKonut.EkspertizAndRehinAmount")))
    }

    if (result) {
      setAylikOdeme(isNaN(result.aylikOdeme) ? 0 : result.aylikOdeme)
      setTotalPaymentAmt(isNaN(result.totalPaymentAmt) ? 0 : result.totalPaymentAmt)
      setFaizOrani(result.faizOrani)
      setYearlyInterestRate(
        isNaN(result.aylikOdeme) ? "% 0" : "% " + result.yearlyInterestRate.toFixed(4)
      )
      setDetails({
        ...details,
        showSlider: true
      })
    }
  }, [productDetail, amount, vade, details])


  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    if (name === "amount") {
      let eventValue = value === "" ? null : value.replace(/\./g, "").replace(/[^0-9]+/, "")
      let amount = parseInt(eventValue)
      setAmount(amount)
    }

    if (name === "konutDegeri") {
      let eventValue = value === "" ? null : value.replace(/\./g, "").replace(/[^0-9]+/, "")
      let amt = parseInt(eventValue)
      setKonutDegeri(amt)
    }
  }, [])

  const handleSliderChange = useCallback((e?: any, data?: number) => {
    if (data) {
      setVade(data)
    }
  }, [])

  const handleUrunTipiChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "E" && !ilkEvim) {
      setUrunTipi(INSURED_PRODUCT_TYPE)
    } else if (value === "E" && ilkEvim) {
      setUrunTipi(ILK_EVIM_INSURED_PRODUCT_TYPE)
    } else if (value === "H" && !ilkEvim) {
      setUrunTipi(UNINSURED_PRODUCT_TYPE)
    } else {
      setUrunTipi(ILK_EVIM_UNINSURED_PRODUCT_TYPE)
    }
  }, [])

  const handleUsedTypeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "1") {
      setKonutTuru(UNUSED_PRODUCT_TYPE)
    } else {
      setKonutTuru(USED_PRODUCT_TYPE)
    }
  }, [])

  const handleHasAnotherHouseChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "E") {
      setFarkliKonutVarMiFlg(HAS_ANOTHER_HOUSE)
    } else {
      setFarkliKonutVarMiFlg(HAS_NOT_ANOTHER_HOUSE)
    }
  }, [])

  const handleEnergyClassChange = useCallback((e: null, data: any) => {
    if (data) {
      setEnerjiSinifi(data.value)
    }
  }, [])

  // UrunTipi seçimi sonrası tetiklenen useEffect
  useEffect(() => {
    if (urunTipi) {
      getProductInfo()
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [urunTipi]
  )

  // Tutar, Vade ya da ürün detayları güncellendiğinde tetiklenen hesaplama useEffecti
  useEffect(() => {
    if (amount || vade || Object.keys(productDetail).length !== 0) {
      calculatePayment()
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [amount, vade, productDetail])

  const formatErrorMessage = (errorMessage: string): string => {
    const numberRegex = /(?:\d{1,3}(?:[.,]\d{3})+|\d+)(?:\.\d+)?/g;
    const matches = errorMessage.match(numberRegex);

    if (!matches) {
      return errorMessage
    }

    for (const match of matches) {
      const number = parseFloat(match.replace(/[^\d.]/g, ''));
      const formattedNumber = new Intl.NumberFormat('tr-TR').format(number);
      errorMessage = errorMessage.replace(match, formattedNumber)
    }

    return errorMessage;
  }

  const [preApply1] = usePreApply1Mutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if ((vade as number) > 0 && urunTipi !== "") {
        dispatch(
          setCustomerData({
            tutar: amount,
            vade: vade,
            urunTipi: urunTipi
          })
        )
        preApply1({
          urunTipi: urunTipi,
          krediTutari: amount,
          konutTuru: konutTuru,
          konutDegeri: konutDegeri,
          farkliKonutVarMiFlg: farkliKonutVarMiFlg,
          enerjiSinifi: enerjiSinifi,
          krediVade: vade,
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              history.push({
                pathname: "/details/initialinfo"
              })
            } else {
              window.scrollTo({
                top: 0,
              });
              if (payload.ErrorMessage && (payload.ErrorCode === MAX_LTV_VALUE_ERROR_CODE || payload.ErrorCode === MAX_USED_VALUE_ERROR_CODE)) {
                setError(formatErrorMessage(payload.ErrorMessage))
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            }
          })
      }
    },
    [dispatch, history, amount, vade, urunTipi, konutTuru, konutDegeri, farkliKonutVarMiFlg, enerjiSinifi]
  )
  return (
    <Page>
      <Form onChange={handleChange} onSubmit={handleSubmit}>
        <FormMessage className="form-msg-error" error={error}></FormMessage>
        <Panel hasFooter connected={false} loading={isLoading}>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description-landing">
              {getConfigValue(configValues, ilkEvim ? "WebKonut.Landing.HeaderText.ilk-evim" : "WebKonut.Landing.HeaderText")}
            </Element>
            <Amount
              id="amount"
              name="amount"
              label="Kredi Tutarı"
              value={{ amount: amount, currency: "888" }}
              withDecimalPart={false}
              withCurrency={false}
              maxLength={9}
              allowDecimals={false}
              allowNegativeValue={false}
              align={"left"}
              placeholder={"Lütfen Kredi Tutarı giriniz."}
            />
            <RadioGroup
              value={urunTipi === INSURED_PRODUCT_TYPE || urunTipi === ILK_EVIM_INSURED_PRODUCT_TYPE ? "E" : "H"}
              name="sigortaRadio"
              onChange={handleUrunTipiChange}
              block={false}>
              <Radio label="Sigortalı" name="sigortaRadio" value="E" />
              <Radio label="Sigortasız" name="sigortaRadio" value="H" />
            </RadioGroup>
            <RadioGroup
              value={konutTuru === UNUSED_PRODUCT_TYPE ? "1" : "2"}
              name="isUsedRadio"
              onChange={handleUsedTypeChange}
              block={false}>
              <Radio label="Sıfır" name="kullanimRadio" value="1" />
              <Radio label="İkinci El" name="kullanimRadio" value="2" />
            </RadioGroup>
            <Amount
              id="konutDegeri"
              name="konutDegeri"
              label="Konut Değeri"
              value={{ amount: konutDegeri, currency: "888" }}
              withDecimalPart={false}
              withCurrency={false}
              maxLength={9}
              allowDecimals={false}
              allowNegativeValue={false}
              align="left"
              placeholder="Lütfen konut değeri giriniz."
            />
            <Select
              label="Enerji Sınıfı"
              name="enerjiSinifi"
              placeholder="Seçiniz"
              options={energyClassOptions}
              clearValueText={"temizle"}
              displayField="name"
              valueField="id"
              onChange={handleEnergyClassChange}
            />
            <Block className="tooltip-container">
              <RadioGroup
                value={farkliKonutVarMiFlg === HAS_ANOTHER_HOUSE && !ilkEvim ? "E" : "H"}
                name="hasAnotherHouseRadio"
                onChange={handleHasAnotherHouseChange}
                block={false}
                label="Ailenin farklı konutu var mı?">
                <Radio label="Evet" name="hasAnotherHouseRadio" value="E" />
                <Radio label="Hayır" name="hasAnotherHouseRadio" value="H" />
              </RadioGroup>
              {ilkEvim &&
                <Block className="tooltip-item">
                  <Tooltip text={getConfigValue(configValues, "WebKonut.Landing.ToolTipText")}>
                    <Button
                      size="xxsmall"
                      className="tooltip-button"
                    >
                      <UiInfo
                        className="tooltip-icon"
                        size={32}
                      />
                    </Button>
                  </Tooltip>
                </Block>
              }
            </Block>
            {details.showSlider && (
              <Slider
                label="Vade"
                name="vadeSlider"
                min={productMinsMaxs.minVade}
                max={productMinsMaxs.maxVade}
                step={1}
                defaultValue={vade}
                valueTitle="Ay"
                included
                onChange={handleSliderChange}
              />
            )}
            <CalculationDetail
              aylikOdeme={aylikOdeme}
              totalPaymentAmt={totalPaymentAmt}
              faizOrani={faizOrani}
              yearlyInterestRate={yearlyInterestRate}
            />
          </Panel.Body>
          <Panel.Footer>
            <Button
              text="Hemen Başvur"
              type="submit"
              className="apply-button"
              fetching={isLoading}
              disabled={isLoading}
            />
          </Panel.Footer>
        </Panel>
      </Form>
    </Page>
  )
}

export default CalculateForm
